import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.search";
import "core-js/modules/web.dom-collections.for-each";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { loading } from '@/decorators';
import { namespace } from 'vuex-class';
var Common = namespace('common');

var SmMessageListPage = function (_super) {
  __extends(SmMessageListPage, _super);

  function SmMessageListPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.isShowLoadMore = false;
    _this.curAnnounceId = 0;
    _this.detailData = {};
    _this.searchData = _this.initSearchData();
    _this.readStatusList = [{
      value: undefined,
      label: _this.t('全部')
    }, {
      value: 0,
      label: _this.t('未读')
    }, {
      value: 1,
      label: _this.t('已读')
    }];
    _this.activeAnnounceCate = 0;
    _this.dataList = [];
    _this.listDataPending = false;
    _this.page = 1;
    _this.pageSize = 10;
    _this.total = 0;
    _this.categoryList = [];
    return _this;
  }

  SmMessageListPage.prototype.initSearchData = function () {
    return {
      type_id: undefined,
      is_acked: undefined,
      keyword: '',
      pre_tags: '<em class="highlight-text">',
      post_tags: '</em>',
      page_index: 1,
      page_size: 20
    };
  };

  SmMessageListPage.prototype.search = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.detailData = {};
            this.dataList = [];
            this.searchData.page_index = 1;
            return [4, this.querySmMessageList(true)];

          case 1:
            _a.sent();

            data = this.dataList[0];

            if (!data) {
              return [2];
            }

            this.detailData = data;
            return [2];
        }
      });
    });
  };

  SmMessageListPage.prototype.setListItemAck = function (id) {
    var _this = this;

    this.dataList.forEach(function (item) {
      if (item.id === id) {
        item.acked = _this.$enum.common.Enabled.YES;
      }
    });
  };

  SmMessageListPage.prototype.querySmMessageCateList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.announce.querySmMessageCateList()];

          case 1:
            data = _a.sent().data;
            this.categoryList = data.list;
            return [2];
        }
      });
    });
  };

  SmMessageListPage.prototype.querySmMessageList = function (resetListStatus) {
    return __awaiter(this, void 0, Promise, function () {
      var resData, _a, list, _b, total, totalPage;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4, this.$api.announce.querySmMessageList(this.searchData)];

          case 1:
            resData = _c.sent().data;
            _a = resData.list, list = _a === void 0 ? [] : _a, _b = resData.total, total = _b === void 0 ? 0 : _b;
            this.dataList = resetListStatus ? list : this.dataList.concat(list);
            this.total = total;
            totalPage = Math.ceil(this.total / Number(this.searchData.page_size));
            this.isShowLoadMore = Number(this.searchData.page_index) < totalPage;
            return [2];
        }
      });
    });
  };

  SmMessageListPage.prototype.setSmMessageAckBulk = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.announce.setSmMessageAckBulk(param)];

          case 1:
            data = _a.sent().data;
            return [2, data];
        }
      });
    });
  };

  SmMessageListPage.prototype.handleClickAnnounce = function (item) {
    return __awaiter(this, void 0, Promise, function () {
      var unreadTotalData;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.detailData = item;
            if (!(item.acked !== this.$enum.common.Enabled.YES)) return [3, 2];
            return [4, this.setSmMessageAckBulk({
              id_list: [item.id]
            })];

          case 1:
            unreadTotalData = _a.sent();
            this.$store.commit('user/SET_UNREAD_TOTAL', unreadTotalData);
            this.setListItemAck(item.id);
            _a.label = 2;

          case 2:
            return [2];
        }
      });
    });
  };

  SmMessageListPage.prototype.handleSearch = function () {
    this.search();
  };

  SmMessageListPage.prototype.handleLoadMore = function () {
    this.page += 1;
    this.searchData.page_index = this.page;
    this.querySmMessageList();
  };

  SmMessageListPage.prototype.handleTabChange = function (key) {
    this.search();
  };

  SmMessageListPage.prototype.handleReadStatusChange = function () {
    this.search();
  };

  SmMessageListPage.prototype.created = function () {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        this.querySmMessageCateList();
        this.search();
        return [2];
      });
    });
  };

  __decorate([loading('listDataPending')], SmMessageListPage.prototype, "querySmMessageList", null);

  SmMessageListPage = __decorate([Component], SmMessageListPage);
  return SmMessageListPage;
}(Vue);

export default SmMessageListPage;